import { useEffect, useRef } from "react";
import { HotspotResource } from "../../APIService/Maps";
import { ResourceEquipment, ResourceLocation } from "../../APIService/SearchService";

export interface MapsIFrameData {
  from: string;
  data?: DataObject;
  action?: string;
  locationId?: number;
  mapId?:number;
}
export interface DataObject {
  date: string; //DD/MM/YYYY
  timeRange: {
    start: string; //HH:mm
    end: string; //HH:mm
  };
  spaceType: string;
  occupancy: number;
  selectedResources?: HotspotResource[]
  tags: string[];
  equipment: string[];
  theme: string;
}

export interface IframeResource {
  Id: number;
    ResID: number;
    ResName: string;
    Status: number;
    TitleMandatory: boolean;
    RoomImage: string;
    Occupancy: number;
    Description: string;
    Keywords: string[];
    Equipment: ResourceEquipment[];
    Location: ResourceLocation;
    SpaceType: string;
    SpaceTypeIcon: string;
    MapID: number;
    LocationId: number;
    SetupDuration: number;
    CleardownDuration: number;
    LastUsedOrLastCleaned: string;
    IsRecurringBookingEnabled: boolean;
    BookMandatorySpaceUsageAcceptanceText: string;
    CheckInMandatorySpaceUsageAcceptanceText: string;
}

type ResourceSpaceMapSectionProps = {
  payload?: MapsIFrameData | null;
  // bookingLocation: GetMapsLocation;
  mapId: number;
  onReceiveMessage: (message: MapsIFrameData) => void;
  isSendMessageToIframe: boolean;
}

const ResourceSpaceMapSection = ({
  payload,
  // bookingLocation,
  mapId,
  onReceiveMessage,
  isSendMessageToIframe
}: ResourceSpaceMapSectionProps) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const lastPayloadRef = useRef<MapsIFrameData | null>(null);
  const isUpdateFromIframeRef = useRef<boolean>(false);

  //Origin Url for Production
  const iFrameOrigin = `${localStorage.getItem("tenantUrl")}`;

  //Origin Url for Development
  // const iFrameOrigin = "http://10.10.13.14:4000";

  useEffect(() => {
    return () => {
      iframeRef.current = null;
    };
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== iFrameOrigin) return;
      if (!event.data || event.data.from !== "maps") return;
      const data: MapsIFrameData = event.data
      isUpdateFromIframeRef.current = true;
      onReceiveMessage(data);
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    if (!payload) return;
    if (payload) {
      try {
        const data = payload;
        // if (isEqualPayload(lastPayloadRef.current, payload)) {return;}
        postToIframe(data);
      } catch (err) {
        console.error("Error sending message to iframe:", err);
      }
    }
  }, [payload]);

  //Check if payload is same to avoid duplicates
  const isEqualPayload = (
    prev: MapsIFrameData | null,
    next: MapsIFrameData
  ) => {
    if (!prev) return false;

    return JSON.stringify(prev) === JSON.stringify(next);
  };

  const postToIframe = (payload: MapsIFrameData) => {
    iframeRef.current?.contentWindow?.postMessage(
      payload,
      iFrameOrigin
    );
    lastPayloadRef.current = payload;
  };

  return (
    <>
      <div style={{ width: "100%", height: "100%" }}>
        {mapId && mapId !== 0 && (
          <iframe
            ref={iframeRef}
            id="MapFunc"
            src={`${iFrameOrigin}/MapsV2/?id=${mapId}&workplaces=true`} //Production
            // src={`${iFrameOrigin}/?id=${mapId}&workplaces=true`} //Development LocalHost
            height={"100%"}
            width={"100%"}
          />
        )}
      </div>
    </>
  );
};

export default ResourceSpaceMapSection;
